import { scrollElement } from '@services/sse';
import { setBrowserStorageItem } from './browserStorage';
import { BROWSER_STORAGE_KEYS } from '@constants';

export async function handleScroll(event, elementId, clientViewing = true) {
    if (!clientViewing) {
        const { scrollPositionKey } = BROWSER_STORAGE_KEYS;
        const { scrollTop, scrollLeft } = event.target;
        const storageKey = `${scrollPositionKey}_${elementId}`;
    
        const top = parseInt(Math.ceil(scrollTop));
        const left = parseInt(Math.ceil(scrollLeft));

        await scrollElement({ elementId, top, left });
        
        setBrowserStorageItem(storageKey, { scrollTop, scrollLeft });
    } else {
        console.log('Scroll cannot be controlled by the client');
    }
}

export function updateRefScrollPosition(ref, position, direction = 'scrollTop') {
    ref.current[direction] = position;
}

export function getScrollId(type, elementId) {
    return `${type}_${elementId}`;
}
